export const actionTypes = {
  reprocess: { actionName: 'REPROCESS', actionDisplayString: 'Reprocess' },
  ignore: { actionName: 'IGNORE', actionDisplayString: 'Ignore' },
};

export const characterLimit = 250;

export const pageTypes = {
  webhookLogQueue: 'Webhook Log Queue',
  webhookAcctNotification: 'Webhook Account Notification',
};
